import {
  createTheme,
  ThemeOptions,
  responsiveFontSizes,
  Theme,
} from '@mui/material';

const createResponsiveTheme = (theme: Partial<ThemeOptions>): Theme => {
  return responsiveFontSizes(createTheme(theme));
};

export default createResponsiveTheme;
